import React from 'react';

const AuditContext = React.createContext([]);

export default AuditContext;
